import { mapGetters, mapMutations } from "vuex";
import { objectLength } from "@/utils";
import GoogleConnectionBtn from "@/components/global/GoogleConnectionBtn";
import ErrorModal from "@/components/global/modals/GoogleConnectionError";
import ReconnectModal from "@/components/global/modals/Reconnect";

export const GoogleLoginMixin = {
  data:() => ({
    modal: {
      show: false,
      text: '',
    },
    showReconnectModal: false,
  }),
  components: {
    GoogleConnectionBtn,
    ErrorModal,
    ReconnectModal,
  },
  computed: {
    ...mapGetters(["get_sso_error", "get_adwords_ids", "get_response"]),

    formatted_sso_error() {
      if (!this.get_sso_error?.error) return null;
      return this.get_sso_error.error.replaceAll("_", " ");
    },
  },
  methods: {
    ...mapMutations(["SET_GOOGLE_ERROR"]),

    handleFailure(e) {
      this.$router.push({ params: { support: true } });
            if (e.error === 'idpiframe_initialization_failed') {
        this.modal.show = true;
            this.modal.text = e.details === 'Cookies are not enabled in current environment.'
                ? 'Please enable third party cookies in order to continue.'
                : e.details;
      }
    },

    handleSuccess() {
      const isErrorMsg = (msg) => (this.$store.state.sso.msg || "").toLowerCase() === msg.toLowerCase();
      let route;

      if ( objectLength(this.get_adwords_ids) ) route = "Google Connection Success";
      else if ( isErrorMsg("token not found") ) this.showReconnectModal = true;
      else if ( objectLength(this.get_response.protectedIds) || isErrorMsg('account is already protected by clickcease')  ) route = "Adwords Already Protected";
      else if ( objectLength(this.get_response.ineligibleIds) ) route = "Not Enough Activity";
      else route = "Adwords Not Found";
      
      if (route) this.$router.push({ name: route });
    },
  },
};
